// Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import 'react-bootstrap-modal/lib/css/rbm-patch.css';

// AdminLTE theme
import 'admin-lte';
import 'admin-lte/dist/css/AdminLTE.css';
import 'admin-lte/dist/css/skins/skin-blue.css';

import './style/app.css';

// Fonts
import 'glyphicons';
import 'font-awesome/css/font-awesome.css';

// Other useful plugins
import 'fastclick';
import 'jquery-slimscroll';
import 'react-select/dist/react-select.css';

// Date picker
import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Main page components
import Header from './header/header.jsx';
import Menu from '../menu/menu.jsx';
import Footer from './footer.jsx';

// Pages
import LoginSSO from '../pages/login/ssoLogin.jsx';
import Login from '../pages/login/login.jsx';
import Home from '../pages/home.jsx';
import ParcelsTable from '../pages/parcels/table/parcelsTable.jsx';
import CreateParcelForm from '../pages/parcels/form/createParcelForm.jsx';
import ParcelForm from '../pages/parcels/form/parcelForm.jsx';
import AdminUsersTable from '../pages/admin/users/usersTable.jsx';
import AdminUserForm from '../pages/admin/users/userForm.jsx';
import StatisticsPage from '../pages/statistics.jsx';
import NotFound from '../pages/notFound/notFound.jsx';

//Shepherd
import ShepherdWrapper from "../controls/ShepherdWrapper.jsx";

//Services
import { validateToken } from '../services/apiClient';
import ConfirmModal from '../modals/confirmModal.jsx';

export default class App extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            isLoading: true
        }
        this.isFirstLoadedRender = true;
        this.confirmModal = null;

        this.isFirstShepherdRender = true;
    }

    componentDidMount() {
        var self = this;
        validateToken().then(() => {
            self.setState({
                isLoading: false
            });
        });
    }

    getChangeRouteConfirmation(message, callback) {
        this.confirmModal.open("Подтверждение перехода на другую страницу", message)
            .then(() => {
                callback(true);
            })
            .catch(() => {
                callback(false);
            });
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div className="loading">
                    <img src="/img/spinner.gif" alt="loading" />
                </div>
            );
        } else {
            if (this.isFirstLoadedRender) {
                this.isFirstLoadedRender = false;
                setTimeout(() => {
                    $(window).trigger('resize');
                    $('ul.tree').tree();
                }, 100);
            }
            return (
                <Router getUserConfirmation={(message, callback) => this.getChangeRouteConfirmation(message, callback)}>
                    <Switch>
						<Route exact path="/login" component={Login} />
						<Route exact path="/sso/login" component={LoginSSO} />
                        <Route exact path="/inner/stats" component={StatisticsPage} />
						<Route>
							<div className="wrapper">
								<Header />
								<Menu />
                    
								<div className="content-wrapper">
									<Switch>
                                        <Route exact path="/" component={Home} />
                                        <Route path="/admin/users/list" component={AdminUsersTable} />
                                        <Route path="/admin/users/new" component={AdminUserForm} />
                                        <Route path="/admin/users/:id" component={AdminUserForm} />
                                        <Route path="/parcels/list" component={ParcelsTable} />
                                        <Route path="/parcels/new" component={CreateParcelForm} />
                                        <Route path="/parcels/:id" component={ParcelForm} />
                                        <Route component={NotFound} />
                                    </Switch>
                                    <ShepherdWrapper />
                                </div>
                                <Footer />

                                <ConfirmModal ref={modal => this.confirmModal = modal} />
                            </div>
                        </Route>
                    </Switch>
                </Router>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./App/containers/app.jsx